export const educations = [
  {
    organisation: "Darshan Institute of Engineering and Technology",
    logo: "/education/du-logo.jpg",
    from: "Rajkot, Gujarat, India",
    positions: [
      {
        title: "Diploma Computer Engineering",
        duration: "2022 - 2025",
        content: [
          {
            text: "Completed my diploma in computer engineering with a focus on programming languages and software development.",
          },
          {
            text: "Participated in various coding competitions to enhance my skills.",
          },
          {
            text: "I also archived 1st rank in the floric event called 'Web Frontier' and organized by Darshan University see certificate.",
          },
        ],
      },
    ],
  },
  {
    organisation: "Saraswati Vidhya Mandir",
    logo: "/education/sarswati-school.jpg",
    from: "Rajkot, Gujarat, India",
    positions: [
      {
        title: "SSC",
        duration: "2021 - 2022",
        content: [
          {
            text: "Completed my SSC with a focus on mathematics and science. It's gujarati medium school.",
          },
          {
            text: "I enjoyed study and extracurricular activities, which helped me develop a well-rounded skill set.",
          },
        ],
      },
    ],
  },
];
